import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UrlValidatorService } from '../../core/services/url-validator.service';

@Injectable()
export class CommonToolDataService {
 baseUrl: string = environment.API_URL;

    constructor(private http: HttpClient, private urlValidator: UrlValidatorService) { }

    // Download GBLReport
    downloadGBLReport(projectDetailId: string, toolName: string, selectedVersion: string, selectedLanguage: string, toolObject: any) {
        const sanitizedProjectDetailId = this.urlValidator.sanitizeParam(projectDetailId);
        const sanitizedToolName = this.urlValidator.sanitizeParam(toolName);
        const sanitizedSelectedVersion = this.urlValidator.sanitizeParam(selectedVersion);
        const sanitizedSelectedLanguage = this.urlValidator.sanitizeParam(selectedLanguage);
        const params = new HttpParams()
            .set('projectDetailId', sanitizedProjectDetailId)
            .set('toolName', sanitizedToolName)
            .set('selectedVersion', sanitizedSelectedVersion)
            .set('selectedLanguage', sanitizedSelectedLanguage);
        return this.http.post(this.baseUrl + '/api/Reports/downloadGBLReport', toolObject, { params });
    }

    // Download GBL Checklist
    downloadGBLChecklist(projectDetailId: string, toolName: string, selectedVersion: string, selectedLanguage: string, toolObject: any) {
        const sanitizedProjectDetailId = this.urlValidator.sanitizeParam(projectDetailId);
        const sanitizedToolName = this.urlValidator.sanitizeParam(toolName);
        const sanitizedSelectedVersion = this.urlValidator.sanitizeParam(selectedVersion);
        const sanitizedSelectedLanguage = this.urlValidator.sanitizeParam(selectedLanguage);
        const params = new HttpParams()
            .set('projectDetailId', sanitizedProjectDetailId)
            .set('toolName', sanitizedToolName)
            .set('selectedVersion', sanitizedSelectedVersion)
            .set('selectedLanguage', sanitizedSelectedLanguage);
        return this.http.post(this.baseUrl + '/api/Reports/downloadGBLChecklist', toolObject, { params });
    }
}
